<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
      <v-divider></v-divider>
      <v-card-text class='pt-2'>
        <p class='grey--text'>Scheduling considerations:</p>
        {{ estimate.estimate_detail.scheduling_considerations ? estimate.estimate_detail.scheduling_considerations : 'None...'}}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
      width='450'
    >
      <v-form v-model='isFormValid' ref='form'>
        <wc-datepicker :max='estimateCopy.end_date' v-model='estimateCopy.start_date' label='Lawn Care Start Date'></wc-datepicker>
        <wc-datepicker :min='estimateCopy.start_date' v-model='estimateCopy.end_date' label='Lawn Care End Date'></wc-datepicker>
        <v-card-subtitle class='mt-n3' v-if='monthsOfService'>{{'Lawn Service duration set to ' + monthsOfService + ' months' }}</v-card-subtitle>
        <v-select
          label='Mowing Frequency'
          :items='frequencyOptions'
          dense
          v-model='estimateCopy.frequency'
        ></v-select>
        <v-select
          class='mt-4'
          label='Billing type'
          :items='billingTypes'
          v-model='estimateDetailCopy.billing_type'
        ></v-select>
        <v-textarea
          v-model='estimateDetailCopy.scheduling_considerations'
          outlined
          auto-grow
          hint='Does this job need to be scheduled on a particular day/time?'
          persistent-hint
        ></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'lawn-estimate-details',
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Lawn Care Details',
    icon: 'mdi-view-list',
    iconColor: 'orange',
    isFormValid: false,
    showDialog: false,
    label: 'grey--text',
    estimateCopy: {},
    estimateDetailCopy: {}
  }),
  computed: {
    tableData () {
      return [
        { text: 'Lawn Care Start Date', value: this.estimate.start_date ? this.$options.filters.shortDate(this.estimate.start_date) : 'Not set' },
        { text: 'Lawn Care End Date', value: this.estimate.end_date ? this.$options.filters.shortDate(this.estimate.end_date) : 'Not set' },
        { text: 'Mowing Frequency', value: this.estimate.frequency ? this.getFrequencyDisplay(this.estimate.frequency) : 'Not set' },
        { text: 'Billing Type', value: this.estimateDetail.billing_type_display }
      ]
    },
    billingTypes () {
      return this.$store.state.misc.globalOptions.snowBillingTypes
    },
    monthsOfService () {
      if (this.estimateCopy.start_date && this.estimateCopy.end_date) {
        let end = moment(this.estimateCopy.end_date)
        let start = moment(this.estimateCopy.start_date)
        let duration = moment.duration(end.diff(start))
        return duration.as('months').toFixed(0)
      }
      return null
    },
    frequencyOptions () {
      return this.$store.state.misc.globalOptions.frequency
    },
  },
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.estimateCopy = _.cloneDeep(this.estimate)
      if (!this.estimateCopy.start_date && this.estimate.division_obj.season_starts) {
        this.estimateCopy.start_date = this.estimate.division_obj.season_starts
      }
      if (!this.estimateCopy.end_date && this.estimate.division_obj.season_ends) {
        this.estimateCopy.end_date = this.estimate.division_obj.season_ends
      }
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('update', this.estimateCopy)
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.cancelEdit()
    },
    getFrequencyDisplay (val) {
      if (this.frequencyOptions.find(o => o.value === val) !== undefined) {
        return this.frequencyOptions.find(o => o.value === val).text
      }
      return ''
    },
  }
}
</script>
